// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Checkbox_style_b-icon-warning__mwi1p","checkbox":"Checkbox_style_checkbox__JmIIx","rotate":"Checkbox_style_rotate__yDVut"};